import styled, { keyframes } from "styled-components"
import { cn } from "lib/utils"

// Shimmer animation (optional opt-in)
const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`

// Gentle opacity pulse (default)
const pulse = keyframes`
  0% { opacity: 0.7; }
  50% { opacity: 1; }
  100% { opacity: 0.7; }
`

const StyledSkeleton = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 6px;
  background-color: rgba(0, 0, 0, 0.08);
  animation: ${pulse} var(--skeleton-duration, 2.8s) ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }

  /* Opt-in shimmer mode if needed: <Skeleton data-shimmer="true" /> */
  &[data-shimmer="true"] {
    background: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.045) 25%,
      rgba(0, 0, 0, 0.085) 37%,
      rgba(0, 0, 0, 0.045) 63%
    );
    background-size: 300% 100%;
    will-change: background-position;
    animation: ${shimmer} var(--skeleton-shimmer-duration, 3.2s) cubic-bezier(0.4, 0, 0.2, 1) infinite;
  }
`

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <StyledSkeleton
      data-slot="skeleton"
      className={cn(className)}
      {...props}
    />
  )
}

export { Skeleton }
